import { FC } from "react"
import React,{useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import services from "../../modules/services/services"
//import { useSearchParams } from 'react-router-dom'
import moment from "moment"
import { KTSVG } from "../../../smallnation/helpers"
//import { useNavigate,useParams,useLocation,useHistory } from "react-router-dom";
import {  useLocation, useHistory } from "react-router-dom";
//import {  BrowserRouter as Router, Link,  useLocation} from "react-router-dom";
import { ErrorMessage } from "@hookform/error-message";
import { set, useForm } from "react-hook-form";
import $ from 'jquery';

//import { TablesWidget10, TablesWidget5,TablesWidget1, TablesWidget2,TablesWidget3,TablesWidget4,TablesWidget6,TablesWidget7,TablesWidget8,TablesWidget9,TablesWidget11,TablesWidget12,TablesWidget13  } from "../../../smallnation/partials/widgets"
//import { ProfileDirectoryInc } from "../../../smallnation/partials/widgets/tables/profileDirectoryInc"


const CreateJobLocation: FC = () => {
      const intl = useIntl();
      const red="red";
      let history = useHistory();
      const {
        register,
        formState: { errors },
        handleSubmit
      } = useForm({
        criteriaMode: "all",mode: "onBlur" 
      });

      const submitValue = () => {
        var validateEditorTxt = 1;
        if($('#country_name').val() == ""){
          $("#countyNameValidMsg").show();  
          $(window).scrollTop($('#countyNameValidMsg').position().top);
          validateEditorTxt = 0;     
        }else{
          $("#countyNameValidMsg").hide();  
        }

        if(validateEditorTxt == 0){
          return false;
         }

        const requestObject={
            "siteId":"2",
            "name":$("#country_name").val(),
        }
        console.log(requestObject);
        var accessTokenIn=sessionStorage.getItem("adminAccToken");
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json',
                    'Authorization': "Bearer "+accessTokenIn 
                    //'Authorization': accessTokenIn 
                  },
          body: JSON.stringify(requestObject)
        };

        services.adminCreateJobLocationCounty(requestOptions).then((res) => 
        {
          if (res.code == '200') {
            $("#addlocationsuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
              $("#addlocationsuccessMessage").slideUp(500);
            });
            setTimeout(() => {
              history.push('/joblocationcountrylist');
            }, 1000);
          }
          else{
            $("#addlocationfailMessage").fadeTo(2000, 500).slideUp(500, function () {
              $("#addlocationfailMessage").slideUp(500);
            });
            setTimeout(() => {
            
            }, 1000);
          }
        });
        
      }
     
      useEffect(() => 
      {       
       $('#countyNameValidMsg').hide();
       $('#addlocationsuccessMessage').hide();
       $('#addlocationfailMessage').hide();
      },[]);
      type Props = {
        className: string
      }
      return (
        <>
          <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'Create Job Location County'})}</PageTitle>
          <form   onSubmit={handleSubmit(submitValue)}>     
             <div className="container">
               <div className="row">
                 

                 <div className="col-lg-12">
                 <div className="mb-4">
                 <div className="d-flex flex-column ">
                 <label htmlFor="exampleFormControlInput1" className="required form-label">County Name</label>
                 
                 </div>
                  <input type="text" id="country_name" name="country_name" className="form-control" placeholder="" />
                   <div id="countyNameValidMsg" style={{color:red}} className="error">County Name is required.</div>
              </div>
                 </div>
                
                
                 <div className="col-lg-12">
                 <div className="mb-5 px-3">
                 <div className="d-flex flex-column ">
                 <div className="row mt-2">
                    <div className="divider"></div>
                    <button type="submit" className="btn btn-primary mt-10" style={{maxWidth: "200px"}}> Create County </button>
                 </div>
                 </div>
                 <div id="addlocationsuccessMessage" className="alert alert-success" role="alert">County Created Successfully</div>
                 <div id="addlocationfailMessage" className="alert alert-danger" role="alert">Please try again</div>
              </div>
                 </div>

               </div>
             </div>
             </form>
        </>
      )
    }
export {CreateJobLocation}